import { ColDef, GridOptions } from '@ag-grid-community/core';
import { FundamentalAttr } from '../../models/FundamentalMetrics';

export const getRPCalculatorColumns = (currency?: string): ColDef<FundamentalAttr>[] => [
  {
    field: 'group',
    rowGroup: true,
    hide: true,
  },
  {
    colId: 'label',
    field: 'label',
    headerName: `Fundamental (${currency})`,
    sortable: false,
    resizable: false,
  },
  {
    colId: 'originalValue',
    field: 'value',
    headerName: 'Original',
    cellClass: 'original-value',
    sortable: false,
    resizable: false,
    width: 86,
    valueFormatter: (param) => param.value.toLocaleString('en-US'),
  },
  {
    colId: 'modifiedValue',
    headerName: 'Modified',
    sortable: false,
    resizable: false,
    width: 86,
    valueFormatter: (param) => param.value,
  },
];

export const RPCalculatorGridOptions: GridOptions<FundamentalAttr> = {
  groupDisplayType: 'groupRows',
  groupDefaultExpanded: 1,
  groupRowRendererParams: {
    suppressCount: true,
  },
};

export const RPCalculatorAutoGroupColDef: ColDef<FundamentalAttr> = {
  cellRendererParams: {
    suppressCount: true,
    checkbox: true,
  },
};
